// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/two-by-two.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const twoByTwo: Score = {
  slug: "two-by-two",
  n: 21,
  title: "Two by Two",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [2, 4],
  tempo: 92,
  staves: 1,
  clefs: ["treble"],
  bars: 8,
  barQuarters: 2.0,
  lowest: 60,
  highest: 67,
  hasLyrics: false,
  jasonNote: "Two beats in a bar this time \u2014 count ONE two, ONE two. It marches. Keep your hand still and let the barlines do the work.",
  teaches: ["two beats in a bar", "counting in 2", "five-finger position on C"],
  art: "/sight-reading/art/two-by-two.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/two-by-two.jpg",
  newForThisEdition: true,
  fillsGap: "The printed book contains no 2/4 anywhere.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 2, hand: "rh", start: 2.0, dur: 2.0, midi: 64, pitch: "E4", d: "half" },
    { bar: 3, hand: "rh", start: 4.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 3, hand: "rh", start: 5.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 4, hand: "rh", start: 6.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 5, hand: "rh", start: 8.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 5, hand: "rh", start: 9.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 6, hand: "rh", start: 10.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 6, hand: "rh", start: 11.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 7, hand: "rh", start: 12.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 7, hand: "rh", start: 13.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 8, hand: "rh", start: 14.0, dur: 2.0, midi: 60, pitch: "C4", d: "half" },
  ],
};
